const state = {
  estrategias: [],
  cedula: "",
  fecha_nacimiento: "",
  datos_men: null,
  datos_cpe: null,
  valida: false,
  debeActualizar: false,
  estrategia: "",
  cargandoRuta: false
};

export default state;
